import React, { Component } from 'react'
import Subheader from '../../components/Default/Subheader'
// import Subheader from '../../components/UserAgreement/Subheader'

// eslint-disable-next-line camelcase
export class DEFAULT extends Component {
  handlePrintClick = e => {
    e.preventDefault()
    window.print()
  }
  render() {
    return (
      <div className="template-wrapper">
        <Subheader />
        <div dangerouslySetInnerHTML={{ __html: this.props.pageContent }} />
      </div>
    )
  }
}

export default DEFAULT
